/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useRef, useState } from 'react'
import HeaderSection from '../../common/headerSection'
import PageHeader from '../../common/pageHeader'
import CustomToast from '../../../widgets/toaster'
import { TfiClose } from 'react-icons/tfi'
import { CiCircleRemove } from 'react-icons/ci'
import { BsQrCodeScan } from 'react-icons/bs'
import { IoSearchSharp } from 'react-icons/io5'
import { useTranslation } from 'react-i18next'
import { userService } from '../../../service/plateServices'
import Select from 'react-select/dist/declarations/src/Select'
import AlertModal from '../../../widgets/alertModal'

const NoTest = () => {

    //toaster section
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("");
    const [newResult, setResult] = useState("");
    const [selectedSerielNo, setSelectedSerielNo] = useState("");
    interface Errors {
        remarks?: string;
        reason_id?: string;
        other_reason?: string;
        scan_plate?: string;
    }
    const [errors, setErrors] = useState<Errors>({});
    const [plateBySerielNo, setPlateBySerielNo] = useState<Array<any>>([]);
    const [plateAlert, setPlateAlert] = useState("");
    const [addExceptionData, setAddExceptionData] = useState({
      reason: "",
      remarks: "",
    });
    const [showNoTestAlert, setShowNoTestAlert] = useState(false)
    const [userId, setUserId] = useState<number>(0);
    const [clicked, setClicked] = useState(false);
    const [show, setShow] = useState(false);
    const [debouncedScanCode, setDebouncedScanCode] = useState('');
    const [haveSlNo, setHaveSlNo] = useState(false);
    
    

    const { t } = useTranslation();
    const scanAreaRef = useRef<HTMLInputElement>(null);


    //get plate details by serial number on add exception 
    const getPlateDetailsBySerielNo = async (slNo: string) => {
        let process = ""
        if (slNo !== "") {
            try {
            const response = await userService.listAutoClavePlateBySerielNo(slNo, process);
            if (response.status && response.statusCode === 200) {
                try {
                if (response.data && typeof response.data === 'object' && response.data.plate_status === "1") {
                    const statusNumber = parseInt(response.data.plate_status, 10);
                    let plateStatus = userService.getPlateStatus(statusNumber);
                    if (response.data.next_process_keyword === "incubation" && response.data.incubation_counter === "0") {
                        setPlateAlert("with few plates are in different activity")
                    }
                
                    // Function to get incubation order suffix
                    const getOrdinalSuffix = (num: number): string => {
                        if (num % 100 >= 11 && num % 100 <= 13) return "th";
                        switch (num % 10) {
                            case 1: return "st";
                            case 2: return "nd";
                            case 3: return "rd";
                            default: return "th";
                        }
                    };
                
                    // Modify plateType based on incubation counter
                    if ((statusNumber === 12 || statusNumber === 13) && response.data.incubation_counter > 0) {
                        const suffix = getOrdinalSuffix(response.data.incubation_counter);
                        plateStatus = `${response.data.incubation_counter}${suffix} ${plateStatus}`;
                    }
                    let rowData = [{
                    plateSerielId: response.data.id,
                    productionName: response.data.production_schedule_name,
                    productName: response.data.product_name,
                    plateType: plateStatus,
                    batchId: response.data.batch_number,
                    plateSerielNo: response.data.serial_number,
                    activity: response.data.master_activity_name,
                    area: response.data.area_name,
                    location: response.data.location_name,
                    user: response.data.assigned_operator_name,
                    }];
                    // setPlateBySerielNo(rowData);
                    const uniqueUpdatedDataWithSlno = rowData.filter((newElement: any) => {
                    return !plateBySerielNo.some((existingElement) => existingElement.plateSerielNo === newElement.plateSerielNo);
                    });

                    setPlateBySerielNo((prevUserRoleList) => [...prevUserRoleList, ...uniqueUpdatedDataWithSlno]);
                } else if (response.data.plate_status !== "1") {
                    setToastMessage("This Plate QR has already been used and cannot be marked as ‘No Test'");
                    setToastType("error")
                    setShowToast(true)
                }
                } catch (error) {
                console.log(error);
                }
            } else {
                // setPlateBySerielNo([]);
                setToastMessage(response.message);
                setToastType("error")
                setShowToast(true)
            }
            } catch (error) {
            console.error('Plate response', error);
            }
        } else {
            console.log("no slno")
        }
    }

    // handle plate serielno scan
    const handleScanSerielNo = (result: any) => {    
    if (haveSlNo) {
      setHaveSlNo(false);
      return;
    }

    if (result.trim() !== "") {
      try {
        const parsedResult = JSON.parse(result);

        if (typeof parsedResult === 'object' && parsedResult !== null) {
          let serialNumber;

          // Case-insensitive search for 'serial_number'
          const serialKey = Object.keys(parsedResult).find(
            key => key.toLowerCase() === 'serial_number'
          );

          if (serialKey) {
            serialNumber = parsedResult[serialKey];
          } else {
            setToastMessage(t("exceptionHandling.noSerialNoFound"));
            setToastType("error");
            setShowToast(true);
          }

          if (serialNumber) {
            getPlateDetailsBySerielNo(serialNumber);
            setResult(serialNumber);
            setHaveSlNo(true);
          }
        } else {
          setToastMessage(t("exceptionHandling.parsedResultAlert"));
          setToastType("error");
          setShowToast(true);
        }
      } catch (error) {
        setToastMessage(t("exceptionHandling.noSerialNoFound"));
        setToastType("error");
        setShowToast(true);
        console.error('Error parsing JSON:', error);
      }
    }
    };

    //handle exception alerts 
    const handleExceptionAlert = () => {
      const errors: Errors = {};
      if (plateBySerielNo.length === 0) {
        errors.scan_plate = t('exceptionHandling.errors.scanPlate');
      }
      if (!addExceptionData.reason ) {
        errors.reason_id = t('exceptionHandling.errors.reason');
      }
      if (!addExceptionData.remarks ) {
        errors.remarks = t('exceptionHandling.errors.remark');
      }

      // If there are any errors, display them to the user and disable the submit button.
      if (Object.keys(errors).length > 0) {
        console.log(errors, "errors")
        setErrors(errors);
        return;
      }
      setShowNoTestAlert(true)
      setErrors({});
    }

    //handle exception on change events 
    const handleAddExceptionChange = (e: any) => {
      const { name, value } = e.target;
      const errors: Errors = {};

      let regex;
      if (name === "reason" || name === "remark") {
        regex = /^[a-zA-Z][a-zA-Z0-9 ]*$/;
      } 
      if (value === "") {
        // console.log("haa122")
      } else if (regex && !regex.test(value)) {
        return
      }

      const isWithinLimit = value.length < 500;
      if (name === "remarks") {
        if (!isWithinLimit) {
          errors.remarks = `You have exceeded the character limit`;
        } else {
          setAddExceptionData((prevFormData: any) => ({
            ...prevFormData,
            [name]: value,
          }));
        }
      }

      if (name === "reason") {
        if (!isWithinLimit) {
          errors.reason_id = `You have exceeded the character limit`;
        } else {
          setAddExceptionData((prevFormData: any) => ({
            ...prevFormData,
            [name]: value,
          }));
        }
      }

      setErrors(errors);

    };

    // handle remove icon click
    const handleRemovePlate = (id: any) => {
        setPlateBySerielNo((prevState: any) => prevState.filter((plate: any )=> plate.plateSerielId !== id));
    }

    // handle cancel click
    const handleCancelClick = () => {
      setPlateBySerielNo([])
      setErrors({});
      setAddExceptionData({
        reason: "",
        remarks : ""
      })
      setClicked(false)
    }

    //handle plate sampling submit api call 
    const handlePlateSamplingSubmit = async () => {
      const dataToSend = {
        "user_id": userId,
        "plate_ids": plateBySerielNo.map((plate: any) => plate.plateSerielId).join(','),
        "reason": addExceptionData.reason,
        "remarks": addExceptionData.remarks,
        "interface_name": "Add No Test"
      }
  
      try {
        const response = await userService.assignNoTest(dataToSend);
        if (response.status && response.statusCode === 200) {
          setToastType("success")
          setToastMessage(response.message)
          setShowToast(true)
          setShowNoTestAlert(false)
          handleCancelClick()
          // navigate("/scanArea")
        } else {
          setToastType("error")
          setToastMessage(response.message)
          setShowToast(true)    
        }
      } catch (error) {
        console.error('Plate response', error);
      }
    }

    const handleClick = () => {
        setClicked(true); // Mark as clicked forever
        getPlateDetailsBySerielNo(selectedSerielNo);
    };

    //get logged in user details
    useEffect(() => {
      var storedData = localStorage.getItem('userDetails');
  
      if (storedData) {
        var storedObject = JSON.parse(storedData);
        setUserId(storedObject[0].id)
      }

      if (scanAreaRef.current) {
        scanAreaRef.current.focus();
      }
    }, [])

    useEffect(() => {
        // Set a timer to update debouncedScanCode after 10 seconds
        const timerId = setTimeout(() => {
          setDebouncedScanCode(newResult);
        }, 3000);
    
        // Cleanup the timer if the component is unmounted or scanCode changes
        return () => clearTimeout(timerId);
      }, [newResult]);
    
    useEffect(() => {
      if (debouncedScanCode) {
        handleScanSerielNo(debouncedScanCode);
      }
    }, [debouncedScanCode]);
    
    

  return (
    <div>
        <HeaderSection />
              <PageHeader pageHeader={t("noTest.heading")} pageDescription={t('pageDescription.noTest.description')} />
              <CustomToast
                show={showToast}
                onClose={() => setShowToast(false)}
                delay={5000}
                message={toastMessage}
                toastType={toastType}
              />
            <div>
                <div>
                <CustomToast
                    show={showToast}
                    onClose={() => setShowToast(false)}
                    delay={5000}
                    message={toastMessage}
                    toastType={toastType}
                    // toastPosition='topLeft'
                /> 
                <div className='d-flex'>
                  <div className="scanWrap p-3" style={{"width": "48%"}}>
                    <div className="scanInputWrap p-2">
                      <input
                        onChange={(e) => setResult(e.target.value)}
                        placeholder={t('exceptionHandling.scanOnly')}
                        value={newResult}
                        ref={scanAreaRef}
                      />
                      {newResult && (
                        <CiCircleRemove 
                          onClick={() => setResult("")} 
                          fontSize={30} 
                          color="red"
                          className="m-1"
                          style={{"cursor": "pointer"}}
                        />
                      )}
                      <div className="scanBg ">
                        <BsQrCodeScan />
                      </div>
                    </div>
                    {errors.scan_plate && (
                      <p className="errorText p-0 m-0">{errors.scan_plate}</p>
                    )}
                  </div>
        
                  <div className="scanWrap p-3" style={{"width": "52%"}}>
                        {/* <label style={{"display": "flex"}}>Search Area / Location / Equipment QR Code</label> */}
                        <div className="scanInputWrap p-2">
                        <input
                            onChange={(e) => {
                              setSelectedSerielNo(e.target.value)
                              setClicked(false)
                            }}
                            placeholder={t('exceptionHandling.typeSearch')}
                        />
                        < IoSearchSharp 
                            fontSize={25} 
                            className='mt-1' 
                            color='grey'
                            style={{"cursor":"pointer"}} 
                            display={clicked ? "none" : ""}
                            onClick={handleClick}
                        />
                        </div>
                  </div>
                </div>
                
                <div className="px-3 mx-2" style={{"overflow" : "scroll", "height": "180px"}}>
                    <table className="custom-table">
                    <thead >
                        <tr className="tableHeadRow">
                        <th scope="col" className="tableHeadData2">{t('tableCommon.sl_no')}</th>
                        <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.production_schedule')}</th>
                        <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.product_name')}</th>
                        <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.seriel_number')}</th>
                        <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.activity')}</th>
                        <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.area')}</th>
                        <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.location')}</th>
                        <th scope="col" className="tableHeadData2">{t('exceptionHandling.plateStatus')}</th>
                        <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.assignedUser')}</th>
                        <th scope="col" className="tableHeadData2">{t('exceptionHandling.remove')}</th>
                        </tr>
                    </thead>
                    <tbody >
                        {plateBySerielNo.map((obj : any, index: number) => (
                        <tr>
                        <td className="tableHeadData" >{index + 1}</td>
                        <td className="tableHeadData" >{obj.productionName}</td>
                        <td className="tableHeadData" >{obj.productName}</td>
                        <td className="tableHeadData" >{obj.plateSerielNo}</td>
                        <td className="tableHeadData" >{obj.activity}</td>
                        <td className="tableHeadData" >{obj.area}</td>
                        <td className="tableHeadData" >{obj.location}</td>
                        <td className="tableHeadData" >{obj.plateType}</td>
                        <td className="tableHeadData" >{obj.user}</td>
                        <td className="tableHeadData" ><CiCircleRemove 
                            onClick={() => handleRemovePlate(obj.plateSerielId)} 
                            fontSize={25} 
                            color="red"
                            style={{"cursor": "pointer"}}
                            /></td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                </div>   

                <div>
                    <div className="selectWrap justify-content-start ps-3">
                        <div className="form-group ms-2 ps-1 ">
                            <label htmlFor="">
                            {t("Exception.reason")}
                            <span style={{ color: "red" }}>*</span>
                            </label>
                            <br />
                            <textarea
                            placeholder={t("Exception.reason")}
                            className="otherReasonTextArea p-2"
                            value={addExceptionData.reason}
                            name="reason"
                            onChange={handleAddExceptionChange}
                            // Add any necessary props for the text area
                            />
                            {errors.reason_id && (
                            <p className="errorText m-0 p-0">{errors.reason_id}</p>
                            )}
                        </div>
                         <div className="form-group ms-2 ps-1 ">
                          <label htmlFor="">
                            {t("Exception.remarks")}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <br />
                          <textarea
                            placeholder={t("Exception.remarks")}
                            className="otherReasonTextArea p-2"
                            value={addExceptionData.remarks}
                            name="remarks"
                            onChange={handleAddExceptionChange}
                            // Add any necessary props for the text area
                          />
                          {errors.remarks && (
                            <p className="errorText m-0 p-0">{errors.remarks}</p>
                          )}
                        </div>
                    </div>
                </div>     
           
                <div className="bottomAreaScreen">
                  <button
                    className="modalCancelBtn me-3"
                    onClick={() => handleCancelClick()}
                  >
                    {t("buttons.cancel")}
                  </button>
                  <div className="d-flex justify-content-end w-100">
                    <button
                      onClick={() => handleExceptionAlert()}
                      className="squareOrangeBtn3"
                    >
                      {t("buttons.submit")}
                    </button>
                  </div>
                  {/* <button className=' squareOrangeBtn3Disabled'>Submit</button> */}
                </div>
                </div>
            </div>

             {/* Alert modal for Add Plate Sampling */}
              <AlertModal
                show={showNoTestAlert}
                onHide={() => setShowNoTestAlert(false)}
                title={t("common.alert")}
                message={t('exceptionHandling.addNoTest')}
                onConfirm={handlePlateSamplingSubmit}
              />

    </div>
  )
}

export default NoTest